interface TeamIdentifier {
  id: number;
}

export const INCOMPLETE_TEAM_DATA_MESSAGE =
  'Some teams could not be loaded. Reload the page before continuing.';

export const haveMatchingTeamIds = (
  expectedTeams: readonly TeamIdentifier[],
  loadedTeams: readonly TeamIdentifier[],
): boolean => {
  if (expectedTeams.length !== loadedTeams.length) return false;

  const expectedIds = new Set(expectedTeams.map(team => team.id));
  const loadedIds = new Set(loadedTeams.map(team => team.id));

  if (expectedIds.size !== expectedTeams.length || loadedIds.size !== loadedTeams.length) {
    return false;
  }

  return [...expectedIds].every(teamId => loadedIds.has(teamId));
};
